import type { Shop, ShopAddress, UseItemResult } from '@mezha/api'
import { baseApi } from '../baseApi'
import { heroApi } from './hero'

/** Shops of the world (change add-trade-craft): goods for silver, the master's recipes and consumables. */
export const tradeApi = baseApi.injectEndpoints({
  endpoints: b => ({
    shops: b.query<ShopAddress[], void>({ query: () => ({ get: "/api/v1/shops" }), providesTags: ["World"] }),
    shop: b.query<Shop, string>({ query: id => ({ get: `/api/v1/shops/${encodeURIComponent(id)}` }), providesTags: (_r, _e, id) => [{ type: 'Shop', id }, 'Shop'] }),
    buy: b.mutation<Shop, { shop_id: string; expected_version: number; item_id: string; quantity: number }>({
      query: ({ shop_id, ...body }) => ({ command: `/api/v1/shops/${encodeURIComponent(shop_id)}/buy`, body }),
      onQueryStarted: async ({ shop_id }, { queryFulfilled, dispatch }) => {
        const { data } = await queryFulfilled
        dispatch(tradeApi.util.upsertQueryData('shop', shop_id, data))
        dispatch(baseApi.util.invalidateTags(['Inventory', 'Hero']))
      },
    }),
    sell: b.mutation<Shop, { shop_id: string; expected_version: number; entry_id: number; quantity: number; unit_price: number }>({
      query: ({ shop_id, ...body }) => ({ command: `/api/v1/shops/${encodeURIComponent(shop_id)}/sell`, body }),
      onQueryStarted: async ({ shop_id }, { queryFulfilled, dispatch }) => {
        try {
          const { data } = await queryFulfilled
          dispatch(tradeApi.util.upsertQueryData('shop', shop_id, data))
          dispatch(baseApi.util.invalidateTags(['Inventory', 'Hero', 'Shop']))
        } catch { /* useCommand displays the server rejection; no local mutation */ }
      },
    }),
    craft: b.mutation<Shop, { shop_id: string; expected_version: number; recipe_id: string }>({
      query: ({ shop_id, ...body }) => ({ command: `/api/v1/shops/${encodeURIComponent(shop_id)}/craft`, body }),
      onQueryStarted: async ({ shop_id }, { queryFulfilled, dispatch }) => {
        const { data } = await queryFulfilled
        dispatch(tradeApi.util.upsertQueryData('shop', shop_id, data))
        dispatch(baseApi.util.invalidateTags(['Inventory', 'Hero', 'Loadout', 'Professions']))
      },
    }),
    useItem: b.mutation<UseItemResult, { expected_version: number; entry_id: number; expected_action_id?: number }>({
      query: body => ({ command: '/api/v1/inventory/use', body }),
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        const { data } = await queryFulfilled
        dispatch(heroApi.util.upsertQueryData('hero', undefined, data.hero))
        dispatch(baseApi.util.invalidateTags(['Inventory', 'Loadout', 'World', 'Professions', 'Shop']))
      },
    }),
  }),
})

export const { useShopsQuery, useSellMutation, useShopQuery, useBuyMutation, useCraftMutation, useUseItemMutation } = tradeApi
